import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiExternalLink } = FiIcons;

const Contact = () => {
  return (
    <section id="contact" className="py-32 bg-white dark:bg-dark-bg border-b border-arch-border dark:border-dark-border relative transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-16">
          <motion.div
            className="lg:col-span-2 space-y-12"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div>
              <div className="flex items-center space-x-4 mb-6">
                <div className="w-8 h-[1px] bg-brand-500"></div>
                <span className="text-xs font-bold text-arch-gray dark:text-gray-400 uppercase tracking-widest">Spolupráce</span>
              </div>
              <h2 className="text-4xl font-bold text-arch-dark dark:text-white tracking-tight mb-6">Zahájit projekt.</h2>
              <p className="text-arch-gray dark:text-gray-400 leading-relaxed text-sm">
                Poskytujeme kompletní technickou podporu architektům a developerům. Od vzorků materiálů až po kalkulaci pro váš konkrétní projekt.
              </p>
            </div>

            <div className="space-y-8 border-t border-arch-border dark:border-dark-border pt-8">
              <div>
                <div className="text-xs font-bold text-accent-teal uppercase tracking-widest mb-1">Produktový specialista</div>
                <div className="text-xl font-bold text-arch-dark dark:text-white">Ing. Roman Doleček</div>
              </div>
              <div>
                <div className="text-xs font-bold text-accent-sage uppercase tracking-widest mb-1">Telefon / WhatsApp</div>
                <div className="text-lg font-mono text-arch-dark dark:text-white">+420 777 016 374</div>
              </div>
              <div>
                <div className="text-xs font-bold text-accent-clay uppercase tracking-widest mb-1">E-mail</div>
                <a href="mailto:info@wallwell.cz" className="text-lg font-bold text-brand-500">info@wallwell.cz</a>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 border-t border-arch-border dark:border-dark-border pt-8 text-xs font-mono text-arch-gray dark:text-gray-500">
              <div>PONDĚLÍ - PÁTEK<br />08:00 — 17:00</div>
              <div>SOBOTA<br />09:00 — 12:00</div>
            </div>
          </motion.div>

          <motion.div
            className="lg:col-span-3 flex flex-col justify-center"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="bg-arch-light dark:bg-dark-surface border border-arch-border dark:border-dark-border p-10 md:p-16 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-2 h-full bg-brand-500"></div>
              <div className="max-w-lg">
                <h3 className="text-2xl font-bold text-arch-dark dark:text-white mb-4">Poptávka materiálu</h3>
                <p className="text-arch-gray dark:text-gray-400 mb-10 leading-relaxed">
                  Pro zanechání vaší poptávky, dotazu nebo specifikaci projektu prosím využijte náš klientský formulář. Po kliknutí budete přesměrováni do našeho zabezpečeného prostředí.
                </p>
                <a
                  href="https://clienthub.heffl.com/forms/frm_7mrtKKf1VjXKe5rM"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center justify-center w-full sm:w-auto space-x-4 bg-brand-500 text-white px-10 py-6 text-sm font-bold uppercase tracking-widest hover:bg-brand-600 transition-all duration-300 shadow-[0_0_20px_rgba(245,176,135,0.3)] hover:shadow-[0_0_40px_rgba(245,176,135,0.6)] hover:-translate-y-1 rounded-sm"
                >
                  <span>Vaše poptávka</span>
                  <SafeIcon icon={FiExternalLink} className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;